/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useMemo, useState } from 'react';

import { ExpandLess, ExpandMore } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Collapse, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';

import { Endpoints, Infer } from 'shared';

import { useOrganizationRolesI18n } from '../../../../../utils/useOrganizationRolesI18n';
import { AdminEmptyList } from '../../AdminEmptyList/AdminEmptyList';
import { useAdminOrganizationInfoListStyles } from '../AdminOrganizationInfoList.styles';

type TeamsInfoListProps = {
  team: Infer<typeof Endpoints.GetTeam>['Response'][200];
};

export const TeamsInfoList = memo<TeamsInfoListProps>(({ team }) => {
  const classes = useAdminOrganizationInfoListStyles();
  const [openTeam, setOpenTeam] = useState(false);
  const organizationRoles = useOrganizationRolesI18n();

  const teamRole = useMemo(() => organizationRoles.find(or => or.key === team.role), [organizationRoles, team.role]);

  return (
    <>
      <ListItem button onClick={() => setOpenTeam(!openTeam)}>
        <ListItemIcon>
          <AssignmentIcon />
        </ListItemIcon>
        <ListItemText primary={team.displayName} secondary={teamRole && teamRole.title} />
        {openTeam ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openTeam} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className={classes.nested}>
          {team.users.length ? (
            team.users.map(u => (
              <ListItem key={u.id}>
                <ListItemIcon>
                  <AccountCircleIcon />
                </ListItemIcon>
                <ListItemText primary={`${u.firstName} ${u.lastName}`} secondary={u.email} />
              </ListItem>
            ))
          ) : (
            <AdminEmptyList />
          )}
        </List>
      </Collapse>
    </>
  );
});
